import Vue from 'vue'
import Card from './Card'
import Child from './Child'
import Button from './Button'
import Checkbox from './Checkbox'
import { HasError, AlertError, AlertSuccess } from 'vform'
import BootstrapVue, { ToastPlugin } from 'bootstrap-vue'
import VueSocialSharing from 'vue-social-sharing'

// Components that are registered globaly.
[
  Card,
  Child,
  Button,
  Checkbox,
  HasError,
  AlertError,
  AlertSuccess
].forEach(Component => {
  Vue.component(Component.name, Component)
})

Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
Vue.use(VueSocialSharing)
